import React, { useState } from "react";
import {
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Image,
  Message,
  Segment,
} from "semantic-ui-react";

function LoginForm({ setUserInfo }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(<></>);

  const login = (a) => {
    const body = new FormData();
    body.append("email", email);
    body.append("password", password);

    // FIXME if not valid toast message
    // e.g. short password OR email not matching a regex

    // else try to login
    fetch("/api/login", { method: "POST", body }).then((resp) => {
      if (resp.status === 200) {
        return resp.json().then(setUserInfo);
      }
      resp.json().then((err) => {
        console.log("error set");
        setError(
          <>
            <div class="ui negative message">
              <div class="header">There was a problem with your login</div>
              <p>{err.description}</p>
            </div>
            <div className="ui divider"></div>
          </>
        );
      });
    });
  };
  const validateForm = (e) => {
    return true;
  };

  // handleSubmit = (event) => {
  //   event.preventDefault();
  // }

  return (
    <>
      <Grid
        textAlign="center"
        verticalAlign="middle"
        className="two column centered"
      >
        <Grid.Column>
          <Image
            src="/altos_research_logo_RGB.png"
            width="50%"
            className="centered"
          />
          <Header as="h2" color="teal" textAlign="center">
            Log in to your Intel account
          </Header>

          {error}

          <Form size="large" onSubmit={login} width="80%">
            <Segment stacked>
              <Form.Input
                fluid
                icon="user"
                iconPosition="left"
                placeholder="Email address"
                onChange={(e, { value }) => setEmail(value)}
              />
              <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                onChange={(e, { value }) => setPassword(value)}
              />

              <Button
                color="teal"
                fluid
                size="large"
                type="submit"
                disabled={!validateForm()}
              >
                Login
              </Button>
            </Segment>
          </Form>
          <Message info>
            Interested in our data? let us know at{" "}
            <a href="mailto:sales@altosresearch.com">sales@altosresearch.com</a>
          </Message>
        </Grid.Column>
      </Grid>

      <Divider
        horizontal
        style={{ color: "#FFA26D", margin: "5em 0" }}
      ></Divider>
    </>
  );
}

export default LoginForm;
